module.exports = __webpack_public_path__ + "media/images/flags/64/Mexico-c83c09472cfa5dcb9fc79122e384722a.png";